import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { StylesProvider } from "@material-ui/core/styles";
import ExtensionInstallModal from "components/Generic/ExtensionInstallModal";
import { resourceTheme } from "styles/config";
import globalStyles from "styles/legacy-base.module.scss";

interface LayoutProps {
  children?: React.ReactNode;
}

// TODO: remove this component
/** @deprecated */

export function DeprecatedStyledLayout({ children }: LayoutProps) {
  return (
    <div className={globalStyles.layout}>
      <ExtensionInstallModal />
      <StylesProvider>
        <ThemeProvider theme={resourceTheme}>
          <CssBaseline />
          {children}
        </ThemeProvider>
      </StylesProvider>
    </div>
  );
}
